export const DOCUMENT_FILTER_FIELDS_AI = {
  externalId: 'metadata.externalId',
};

export const FILTER_TYPE = {
  document: 'document',
  media: 'media',
};

export const MEDIA_TYPE = {
  imported: 'imported',
  userImages: 'userImages',
  documentUserImages: 'documentUserImages',
};

export const TRANSLATION_TYPE = {
  document: 'document',
  email: 'email',
  file: 'file',
};